import React from "react";
import PPMobileCardView from "../../../components/PPMobileCardView";

const Mobile = ({ data, onDelete, onEdit }) => {
  const rows = [
    { label: "Material Type", value: data.materialTypeName, fullWidth: true },
    { label: "M.E.", value: data.metabolizableEnergy },
    { label: "Protein", value: data.protein },
    { label: "Fat", value: data.fat },
    { label: "Fibre", value: data.fibre },
    { label: "Calcium", value: data.calcium },
    { label: "Phosphorus", value: data.phosphorus },
    { label: "Lysine", value: data.lysine },
    { label: "Methionine", value: data.methionine },
  ];

  const menuItems = [
    { label: "Edit", onClick: onEdit },
    { label: "Delete", onClick: onDelete },
  ];

  return (
    <PPMobileCardView
      title={data.materialName}
      rows={rows}
      menuItems={menuItems}
    />
  );
};

export default Mobile;
